import * as React from 'react'

import { Box, Button, Checkbox } from '@factorialco/deprecated-design-system'
import {
  AtsDeleteJobPostingDocument,
  AtsDeleteJobPostingMutation,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  id: number
  onClose: () => void
}

export const DeleteJobPostingModal = ({ id, onClose }: Props) => {
  const [agreeCheckbox, setAgreeCheckbox] = React.useState(false)

  const [deleteJobPostingMutation, { loading }] = useMutation(AtsDeleteJobPostingDocument, {
    extractorFn: (data: AtsDeleteJobPostingMutation) => data.atsMutations.deleteAtsJobPosting,
  })

  const onSubmit = async () => {
    const result = handleResult(
      await deleteJobPostingMutation({
        variables: { id },
        update(cache) {
          cache.evict({ id: cache.identify({ id, __typename: 'AtsJobPosting' }) })
        },
      }),
      () => undefined
    )

    if (result.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.removed_successfully'),
      })
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('ats.jobs.delete_modal.error_message'),
      })
    }

    onClose()
  }

  return (
    <Modal
      illustration="delete"
      title={i18n.t('ats.jobs.delete_modal.title')}
      description={i18n.t('ats.jobs.delete_modal.description')}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <Box flexDirection="row" justifyContent="flexEnd" gap="s8">
          <Button type="secondary" disabled={loading} onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>

          <Button type="negative" disabled={loading || !agreeCheckbox} submit>
            {i18n.t('common.delete')}
          </Button>
        </Box>
      }
    >
      <Checkbox
        checked={agreeCheckbox}
        label={i18n.t('ats.jobs.delete_modal.checkbox_label')}
        onChange={(event) => setAgreeCheckbox(event.target.checked)}
      />
    </Modal>
  )
}
